import React from 'react';
import AppLayout from '../../components/layout/AppLayout';
import ConsoleTest from '../../components/Console/ConsoleTest';

const ResearchandDevelopment: React.FC = () => {


    return (
        <AppLayout title="r&d">
            {/* <div style={{ marginBottom: '20px' }}>
                <TranslateList />
            </div> */}

            {/* Console Component Test */}
            {/* <div style={{ marginTop: '40px', marginBottom: '40px' }}>
                <ConsoleTest />
            </div> */}

            {/* Console Component Test */}
            <div style={{ marginTop: '40px' }}>
                <ConsoleTest />
            </div>
        </AppLayout>
    );
};

export default ResearchandDevelopment;
